import { render, staticRenderFns } from "./callLogging.vue?vue&type=template&id=7045d414"
import script from "./callLogging.vue?vue&type=script&lang=js"
export * from "./callLogging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports